import { Pipe, PipeTransform } from '@angular/core';
import { prettyJson } from '@app/pages/admin/operation-monitoring-page/monitored-output.util';

@Pipe({
  name: 'prettyJson',
  standalone: true,
})
export class PrettyJsonPipe implements PipeTransform {
  transform(value?: string | null, empty = '—'): string {
    return prettyJson(value, empty);
  }
}
